(function() {
  if (window.__wizardLessonsBound) return;
  window.__wizardLessonsBound = true;

  function getCsrf() {
    var m = document.querySelector('meta[name="csrf-token"]');
    return m ? m.getAttribute('content') : '';
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function(m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  function truncate(str, len) {
    str = String(str || '');
    return str.length > len ? str.substring(0, len) + '…' : str;
  }

  function renderMeta(vimeo, content) {
    var items = [];
    if (vimeo) items.push('<span class="mr-3"><i class="fas fa-video"></i> Vimeo: ' + escapeHtml(vimeo) + '</span>');
    if (content) items.push('<span><i class="fas fa-align-left"></i> ' + escapeHtml(truncate(content, 120)) + '</span>');
    return items.length ? '<div class="wizard-lesson-meta text-muted small mb-2">' + items.join('') + '</div>' : '';
  }

  // ponytail: "Agregar lección" reveals an inline form. No DB write until Guardar.
  $(document).on('click', '.add-lesson-btn', function() {
    var btn = this;
    var $block = $(btn).closest('.wizard-chapter-block');
    var chapterId = btn.dataset.chapterId;

    if ($block.find('.wizard-lesson-form').length) return;

    var $form = $(lessonFormHtml({ title: '', vimeo: '', content: '', mode: 'create' }));
    $form.data('mode', 'create');
    $form.data('chapter-id', chapterId);
    $block.find('.add-lesson-row').before($form);
    $form.find('input[name="lesson[title]"]').trigger('focus');
  });

  $(document).on('click', '.wizard-lesson-form .cancel-lesson-form-btn', function() {
    var $form = $(this).closest('.wizard-lesson-form');
    if ($form.data('mode') === 'edit') {
      $form.remove();
    } else {
      $form.remove();
    }
  });

  // ponytail: click lesson title to edit inline.
  $(document).on('click', '.wizard-lesson-edit-btn', function(e) {
    e.preventDefault();
    var btn = this;
    var $row = $(btn).closest('.wizard-lesson-row');
    if ($row.find('.wizard-lesson-form').length) return;

    var $form = $(lessonFormHtml({
      title: $row.data('lesson-title') || '',
      vimeo: $row.data('lesson-vimeo') || '',
      content: $row.data('lesson-content') || '',
      mode: 'edit'
    }));
    $form.data('mode', 'edit');
    $form.data('lesson-id', $row.data('lesson-id'));
    $row.find('.wizard-lesson-header').after($form);
  });

  // ponytail: save handler routes to create or update based on form mode.
  $(document).on('click', '.wizard-lesson-form .save-lesson-form-btn', function() {
    var btn = this;
    var $form = $(btn).closest('.wizard-lesson-form');
    var $row = $form.closest('.wizard-lesson-row');
    var mode = $form.data('mode') || 'create';
    var chapterId = $form.data('chapter-id');
    var lessonId = $form.data('lesson-id');
    var courseId = (location.pathname.match(/courses\/([^\/]+)/) || [])[1];
    var title = $form.find('input[name="lesson[title]"]').val().trim();
    var vimeo = $form.find('input[name="lesson[vimeo]"]').val().trim();
    var content = $form.find('textarea[name="lesson[content]"]').val();

    if (!title) { alert('El título es obligatorio'); return; }
    if (!courseId) return;

    btn.disabled = true;
    btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Guardando...';

    var url, method, data;
    if (mode === 'edit' && lessonId) {
      url = '/courses/' + courseId + '/lessons/' + lessonId;
      method = 'PATCH';
      data = { title: title, vimeo: vimeo, content: content, _method: 'patch' };
    } else {
      url = '/courses/' + courseId + '/course_wizard/add_lesson';
      method = 'POST';
      data = { chapter_id: chapterId, title: title, vimeo: vimeo, content: content };
    }

    $.ajax({
      url: url,
      method: 'POST',
      data: data,
      headers: { 'X-CSRF-Token': getCsrf(), 'Accept': 'application/json' }
    }).done(function(lesson) {
      if (mode === 'edit' && $row.length) {
        updateLessonRow($row, lesson);
        $form.remove();
      } else {
        var $newRow = $(lessonRowHtml(lesson));
        $form.replaceWith($newRow);
        if (window.bindAttachmentBoxes) window.bindAttachmentBoxes($newRow);
      }
    }).fail(function(xhr) {
      alert('Error al guardar: ' + xhr.status);
      console.error('[save_lesson]', xhr.status, hxr.responseText);
    }).always(function() {
      btn.disabled = false;
      btn.innerHTML = '<i class="fas fa-save"></i> ' + (mode === 'edit' ? 'Guardar cambios' : 'Guardar lección');
    });
  });

  // ponytail: AJAX delete lesson stays in the wizard.
  $(document).on('click', '.delete-lesson-btn', function(e) {
    e.preventDefault();
    if (!confirm('¿Eliminar esta lección?')) return;
    var btn = this;
    var lessonId = btn.dataset.lessonId;
    var courseId = (location.pathname.match(/courses\/([^\/]+)/) || [])[1];
    if (!courseId || !lessonId) return;
    $.ajax({
      url: '/courses/' + courseId + '/lessons/' + lessonId,
      method: 'DELETE',
      headers: { 'X-CSRF-Token': getCsrf(), 'Accept': 'application/json' }
    }).done(function() {
      $(btn).closest('.wizard-lesson-row').remove();
    }).fail(function(xhr) {
      alert('Error al eliminar: ' + xhr.status);
    });
  });

  function updateLessonRow($row, lesson) {
    $row.attr('data-lesson-id', lesson.id);
    $row.attr('data-lesson-title', lesson.title);
    $row.attr('data-lesson-vimeo', lesson.vimeo);
    $row.attr('data-lesson-content', lesson.content || '');
    $row.find('.wizard-lesson-title').text(lesson.title);
    var $meta = $row.find('.wizard-lesson-meta');
    if ($meta.length) {
      $meta.replaceWith(renderMeta(lesson.vimeo, lesson.content));
    } else {
      $row.find('.wizard-lesson-header').after(renderMeta(lesson.vimeo, lesson.content));
    }
  }

  function lessonFormHtml(opts) {
    return [
      '<div class="wizard-lesson-form">',
        '<div class="form-group">',
          '<label class="wizard-field-label">Título</label>',
          '<input type="text" name="lesson[title]" class="form-control" placeholder="Ej: Introducción" maxlength="100" value="' + escapeHtml(opts.title) + '" />',
        '</div>',
        '<div class="form-group">',
          '<label class="wizard-field-label">Descripción / apuntes</label>',
          '<textarea name="lesson[content]" class="form-control" rows="4" placeholder="Descripción de la lección">' + escapeHtml(opts.content) + '</textarea>',
        '</div>',
        '<div class="form-group">',
          '<label class="wizard-field-label">ID Vimeo (opcional)</label>',
          '<input type="text" name="lesson[vimeo]" class="form-control" placeholder="123456789" value="' + escapeHtml(opts.vimeo) + '" />',
        '</div>',
        '<div class="d-flex justify-content-end gap-2">',
          '<button type="button" class="btn btn-sm btn-link cancel-lesson-form-btn">Cancelar</button>',
          '<button type="button" class="btn btn-sm btn-custom-orange save-lesson-form-btn"><i class="fas fa-save"></i> ' + (opts.mode === 'edit' ? 'Guardar cambios' : 'Guardar lección') + '</button>',
        '</div>',
      '</div>'
    ].join('');
  }

  function lessonRowHtml(lesson) {
    return [
      '<div class="wizard-lesson-row" data-lesson-id="' + lesson.id + '" data-course-id="' + lesson.course_id + '" data-lesson-title="' + escapeHtml(lesson.title) + '" data-lesson-vimeo="' + escapeHtml(lesson.vimeo) + '" data-lesson-content="' + escapeHtml(lesson.content || '') + '">',
        '<div class="wizard-lesson-header d-flex justify-content-between align-items-center">',
          '<button type="button" class="btn btn-link p-0 wizard-lesson-edit-btn"><strong class="wizard-lesson-title">' + escapeHtml(lesson.title) + '</strong></button>',
          '<div class="wizard-lesson-actions">',
            '<button type="button" class="btn btn-sm btn-link text-danger delete-lesson-btn" data-lesson-id="' + lesson.id + '" title="Eliminar lección"><i class="fas fa-trash"></i></button>',
          '</div>',
        '</div>',
        renderMeta(lesson.vimeo, lesson.content),
        '<div class="attachment-box" data-lesson-id="' + lesson.id + '" data-course-id="' + lesson.course_id + '" data-readonly="false">',
          '<div class="attachment-drop-zone">',
            '<i class="fas fa-cloud-upload-alt"></i>',
            '<p>Arrastrá archivos acá o <a href="#" class="attachment-pick">elegí desde tu dispositivo</a></p>',
            '<small>Acepta pdf, doc, docx, jpg, png, mp4, mp3</small>',
            '<input type="file" class="attachment-file-input" multiple />',
          '</div>',
          '<ul class="attachment-pending-list"></ul>',
          '<ul class="attachment-list"></ul>',
          '<button type="button" class="btn btn-sm btn-custom-orange attachment-upload-btn" disabled="disabled"><i class="fas fa-upload"></i> Cargar archivos</button>',
        '</div>',
      '</div>'
    ].join('');
  }
})();